export const initSimpleParallax = () => {
    const largeViewportWidth = 1024;
    const parallaxElements = document.querySelectorAll('*[data-parallax]');

    const parallaxScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const imgPos = scrollTop / 2 + 'px';

        parallaxElements.forEach((element) => {
            element.style.transform = `translate3d(0, ${imgPos}, 0)`;
        });
    };

    const updateParallaxListener = () => {
        if (window.innerWidth >= largeViewportWidth) {
            if (!window.parallaxEnabled) {
                window.addEventListener('scroll', parallaxScroll);
                window.parallaxEnabled = true;
            }
        } else {
            if (window.parallaxEnabled) {
                window.removeEventListener('scroll', parallaxScroll);
                window.parallaxEnabled = false;
            }
        }
    };

    if (parallaxElements){
        updateParallaxListener();
        window.addEventListener('resize', updateParallaxListener);
    }
};

